/**
 * @generated SignedSource<<61f7895d4ce9bf42ceea6f280b596f55>>
 * @relayHash 20ef368dd524cb011104d487e3e321ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d2ed61938803e8e65eacd850610bb4bdab95032174a49adad0d296e0fa94aa54

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_StatisticsSidebarQuery } from './ui_StatisticsSidebarQuery.graphql';

const node: PreloadableConcreteRequest<ui_StatisticsSidebarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d2ed61938803e8e65eacd850610bb4bdab95032174a49adad0d296e0fa94aa54",
    "metadata": {},
    "name": "ui_StatisticsSidebarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
